import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IUseStartUserSessionProps {
  onSuccess?: (data: IUseStartUserSessionResponse) => void;
  onError?: () => void;
  enabled?: boolean;
}

export interface IUseStartUserSessionResponse {
  is_first_user_session: boolean;
}

export default function useStartUserSession({
  onSuccess,
  onError,
  enabled,
}: IUseStartUserSessionProps): UseQueryResult<IUseStartUserSessionResponse> {
  const axios = useAxios();

  const startUserSession = async () => {
    return await axios
      .post(`/v1/users/sessions/start`)
      .then((r) => r.data as IUseStartUserSessionResponse);
  };

  return useQuery<IUseStartUserSessionResponse>(
    ["startUserSession"],
    startUserSession,
    {
      onSuccess,
      onError,
      enabled,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
}
